/**
 * Every piece of UI that requires javascript should have its own
 * javascript file. Use this file as a template for structuring
 * all JS source files.
 *
 * Patente pour patenter des champs dynamiques dans les formulaires 
 *  
 */

(function (window, $) {
	'use strict';
	var document = window.document;

	var dynamicForm = {

		init: function () {
			this.form = $('form.em-booking-form');
			
			//get all inputs that correspond to the dynamic tag condX
			var groups = this.form.find('.input-group input[name^="cond"]');
			
			this.fields = {};
			
			for(var ii=0;ii<groups.length;ii++){
    			var elem = $(groups[ii]);
    			var fnam = elem.attr('name');
    			var buf = fnam.split('_');
    			
    			if(typeof(this.fields[buf[0]]) == "undefined"){
        			this.fields[buf[0]] = {};
        			this.fields[buf[0]].fieldstrue = [];
        			this.fields[buf[0]].fieldsfalse = [];
    			}
    			
    			if(buf.length==1){
        			//then we're looking at a toggle field
        			elem.change(this.change.bind(this));
    			}else{
        			//then we're looking at an inner field
        			if(buf[1] == "true"){
            			this.fields[buf[0]].fieldstrue.push(fnam);
            			
            			if(!this.form.find('.input-group input[name="'+buf[0]+'"]').prop('checked')){
                			elem.parent().addClass('hidden');
            			}else{
                			elem.parent().removeClass("hidden");
            			}
        			}else{
            			this.fields[buf[0]].fieldsfalse.push(fnam);
            			
            			if(this.form.find('.input-group input[name="'+buf[0]+'"]').prop('checked')){
                			elem.parent().addClass('hidden');
            			}else{
                			elem.parent().removeClass("hidden");
            			}
        			}
    			}
			}
		},
		
		change: function(elem){
    		var me = $(elem.target);
    		var mycheck = me.prop('checked');
    		
    		var myfields = this.fields[me.attr("name")];
    		
    		for(var ii=0;ii<myfields.fieldstrue.length;ii++){
        		if(mycheck){
        		    $('.input-group input[name="'+myfields.fieldstrue[ii]+'"]').parent().removeClass("hidden");
                }else{
                    $('.input-group input[name="'+myfields.fieldstrue[ii]+'"]').parent().addClass("hidden");
                }
    		}
    		for(ii=0;ii<myfields.fieldsfalse.length;ii++){
        		if(!mycheck)
        		    $('.input-group input[name="'+myfields.fieldsfalse[ii]+'"]').parent().removeClass("hidden");
                else
                    $('.input-group input[name="'+myfields.fieldsfalse[ii]+'"]').parent().addClass("hidden");
    		}
    		
		}
	};

	$(document).ready(function () {
		dynamicForm.init();
	});

})(window, jQuery);


